import React from 'react';

import { MobileThemedToggle } from '~/src/dash/components/toggles/MobileThemedToggle';
import { Col, Cols, spacing } from '~/src/dash/publicaUI';
import { DateRange, defaultDateRanges, TimeRange } from '~/src/dash/utils/dateTimeRanges';

interface IMobileDateRangeSelectorProps {
  dateRanges?: DateRange[] | TimeRange[];
  selectedRange: DateRange | TimeRange;
  handleClick: (dateRange: DateRange | TimeRange) => void;
}

export const MobileDateRangeSelector = ({
  selectedRange,
  handleClick,
}: IMobileDateRangeSelectorProps) => {
  return (
    <Cols
      gap={spacing.small}
      className='hide-scrollbar'
      style={{
        alignItems: 'center',
        overflowX: 'auto',
      }}
    >
      {defaultDateRanges.map((range) => {
        return (
          <Col>
            <MobileThemedToggle
              active={range.key === selectedRange}
              onClick={() => handleClick(range.key)}
              size='small'
              value={range.shortLabel}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
